import { Button, styled } from "@mui/material";

/**
 * CssButtonOutlined component is a styled Material-UI Button with custom styles.
 *
 * @param {object} props - Component props.
 * @param {string} [props.width="60%"] - Button width.
 * @param {string} [props.height="66px"] - Button height.
 * @param {string} [props.color] - Text color of the button.
 * @param {string} [props.borderColor] - Border color of the button.
 * @param {string} [props.boxShadowColor] - Box shadow color of the button.
 *
 * @returns {JSX.Element} Styled Material-UI Button component.
 */
export const CssButtonOutlined = styled(Button, {
  shouldForwardProp: (prop) =>
    ![
      "borderColor",
      "boxShadowColor",
      "borderRadius",
      "width",
      "height",
    ].includes(prop),
})(
  ({
    theme,
    width,
    height,
    color,
    borderColor,
    boxShadowColor,
    borderRadius,
  }) => ({
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "15px 25px",
    gap: "10px",
    width: width || "60%",
    fontFamily: "Lexend",
    textTransform: "none",
    fontWeight: 500,
    height: height || "66px",
    margin: "2%",
    fontSize: 19,
    border: borderColor ? `5px solid ${borderColor}` : undefined,
    color: color || theme.palette.text.primary,
    borderRadius: borderRadius || "32px",
    textOverflow: "clip",
    whiteSpace: "normal",
    overflow: "hidden",
    lineHeight: 1,
    boxShadow: boxShadowColor ? `10px 10px 37px 0px ${boxShadowColor}` : "none",
  }),
);
